import React, { FC, useState } from 'react'
import { ButtonPrimary, Heading, Text } from 'front-end/src/components'
import { t, Trans } from '@lingui/macro'
import { brandColors } from 'shared/basicPalette'
import Form from 'front-end/src/components/common/form/Form'
import { notification } from 'front-end/src/components/common/notifications/Notifications'
import { navigateTo } from 'front-end/src/app/util/appHistory'
import { linkBuilder } from 'shared/linkBuilder'
import Label from 'front-end/src/components/common/form/label/Label'
import Input from 'front-end/src/components/common/form/input/Input'
import emailRegex from 'front-end/src/app/services/emailRegex'
import IconArrowRight from 'front-end/src/components/common/icon/IconArrowRight'
import { useGenerateResetPasswordLinkMutation } from 'front-end/src/pages/auth/reset-password/ResetPassword.codegen'
import { useParams } from 'react-router-dom'

export const ResetPasswordViaEmailRequestForm: FC<{ organisationId: number }> =
  ({ organisationId }) => {
    const { userIdentity: userIdentityParam } =
      useParams<{ userIdentity?: string }>()
    const [userIdentity, setUserIdentity] = useState(userIdentityParam || '')

    const [generateResetPasswordLink, { loading }] =
      useGenerateResetPasswordLinkMutation({
        onCompleted: () => {
          // even if email is not valid, we show success message for security reasons
          notification.info(t`Email sent successfully `)
          navigateTo(linkBuilder.resetPasswordSent(userIdentity))
        }
      })

    return (
      <>
        <Heading size="md">
          <Trans>It's OK, we all do it.</Trans>
        </Heading>
        <Text pb="4px" pt="12px" color={brandColors.grey['800']}>
          <Trans>
            Just enter the email address you signed up with. We will send you a
            new link so you can reset your password.
          </Trans>
        </Text>
        <Text pb="4px" pt="12px" color={brandColors.grey['800']}>
          <Trans>And we promise not to tell anyone.</Trans>
        </Text>

        <Form
          className="form"
          onSubmit={async () => {
            await generateResetPasswordLink({
              variables: {
                email: userIdentity,
                organisationId
              }
            })
          }}
        >
          <div className="form-row">
            <Label htmlFor="inputEmail">
              <Trans>Your email</Trans>
            </Label>
            <Input
              type="email"
              defaultValue={userIdentity}
              id="inputEmail"
              fullWidth
              placeholder="you@email.com"
              onChange={(value) => {
                setUserIdentity(value)
              }}
            />
          </div>

          <div className="form-row">
            <ButtonPrimary
              className="ResetPasswordButton"
              isFullWidth
              type="submit"
              isLoading={loading}
              isDisabled={loading || !emailRegex.exec(userIdentity)}
              rightIcon={<IconArrowRight />}
            >
              <span className="btn__text">
                <Trans>Reset password</Trans>
              </span>
            </ButtonPrimary>
          </div>
        </Form>
      </>
    )
  }
